var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import YouTubePlayer from 'youtube-player';
class VideoPlayer {
    constructor() {
        this.getYoutubeId = (url) => {
            const urlArray = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
            return (urlArray[2] !== undefined) ? urlArray[2].split(/[^0-9a-z_\-]/i)[0] : urlArray[0];
        };
        this.init = () => {
            var _a;
            //initialize the player
            this.player = YouTubePlayer('yt-player', {
                width: '100%'
            });
            const videoPlaylistBlock = document.querySelector('.video-playlist-block');
            this.playlist = JSON.parse(videoPlaylistBlock.dataset.playlist);
            console.log(this.playlist);
            if (((_a = this.playlist) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const videoItem = this.playFromPlaylist(0, false);
                if (videoItem) {
                    this.setVideoInfo(videoItem);
                }
            }
        };
        this.playFromPlaylist = (index, startPlay) => {
            const videoItem = this.playlist[index];
            const videoId = videoItem.srcYoutube ? this.getYoutubeId(videoItem.srcYoutube) : null;
            console.log(videoId);
            if (videoId) {
                if (this.player.getPlayerState() !== 2) {
                    this.player.loadVideoById(videoId);
                }
                this.currentIndex = index;
                if (startPlay) {
                    this.player.playVideo();
                }
                else {
                    this.player.stopVideo();
                }
                return videoItem;
            }
        };
        this.setVideoInfo = (videoItem) => {
            const videoInfoElement = document.querySelector('.video-player .video-info');
            const titleElement = videoInfoElement.querySelector('.video-info-title');
            const descElement = videoInfoElement.querySelector('.video-info-description');
            if (titleElement) {
                titleElement.innerHTML = videoItem.title;
            }
            if (descElement) {
                descElement.innerHTML = videoItem.description;
            }
        };
        this.resumePlaying = () => {
            this.player.playVideo();
        };
        this.pausePlaying = () => {
            this.player.pauseVideo();
        };
        this.stopPlaying = () => {
            this.player.stopVideo();
        };
        this.getPlayerState = () => __awaiter(this, void 0, void 0, function* () {
            return yield this.player.getPlayerState();
        });
        this.init();
    }
}
export default VideoPlayer;
